import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { getGlobalState, StateService, ThemePreference } from 'kmstack-shared';
import { useKmstackState } from 'kmstack-shared/providers';


export const useAppTheme = () => {
    const dispatch = useDispatch();
    const reduxState = useKmstackState();
    const state = getGlobalState(reduxState);
    const themeMode = state.themeMode || 'system-light';

    useEffect(() => {
        const html = document.documentElement;
        html.classList.remove('dark', 'app-dark', 'light');

        if (themeMode === 'app-dark') {
            html.classList.add('app-dark');
        } else if (themeMode === 'system-dark') {
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            if (prefersDark) {
                html.classList.add('dark');
            }
        } else if (themeMode === 'system-light') {
            html.classList.add('light');
        }

        localStorage.setItem('themeMode', themeMode);
    }, [themeMode]);

    const setThemeMode = (mode: ThemePreference) => {
        dispatch({
            type: StateService.SET_THEME_MODE,
            payload: mode,
        });
    };

    return {
        themeMode,
        setThemeMode,
    };
};



// import { useAppTheme } from "../common/hooks/useAppTheme";

// export const ThemeSwitcher = () => {
//   const { themeMode, setThemeMode } = useAppTheme();

//   return (
//     <div className="flex gap-2 items-center">
//       <span className="text-sm font-medium">Theme:</span>
//       <select
//         value={themeMode}
//         onChange={(e) => setThemeMode(e.target.value as any)}
//         className="border p-1 rounded text-sm"
//       >
//         <option value="system-light">Light</option>
//         <option value="system-dark">System Dark</option>
//         <option value="app-dark">App Dark</option>
//       </select>
//     </div>
//   );
// };
